<template>
  <div class="wrapper">
    <Header></Header>
    <main>
      <router-view></router-view>
    </main>
    <Modals></Modals>
  </div>
</template>

<script>

import Header from "@/components/Layouts/Header";
import Modals from "@/components/Layouts/Modals";

export default {
  name: 'App',
  components: {
    Header,
    Modals
  },
  created() {
    let vm = this;
    let classBody = '';
    if (vm.$route.meta && vm.$route.meta.classBody) {
      classBody = vm.$route.meta.classBody;
    }
    // eslint-disable-next-line no-undef
    let body = $('body');
    body.removeAttr('class');
    body.addClass(classBody);
  },
  watch: {
    $route: {
      handler() {
        let vm = this;
        let classBody = '';
        if (vm.$route.meta && vm.$route.meta.classBody) {
          classBody = vm.$route.meta.classBody;
        }
        // eslint-disable-next-line no-undef
        let body = $('body');
        body.removeAttr('class');
        body.addClass(classBody);
      },
      deep: true
    }
  },
}
</script>

<style lang="scss">
@import "assets/css/bootstrap.min.css";
@import "assets/css/style.css";

.slick-dots {
  position: static !important;

  li {
    display: inline-block !important;
    margin: 2px 4px !important;
    height: 4px !important;
    width: 4px !important;
    background: #759DAF;
    border-radius: 4px;

    button{
      border: 0;
      text-indent: -9999px;
      height: 100%;
      width: 100%;
      opacity: 0;
    }

    &.slick-active {
      height: 8px !important;
      width: 8px !important;
      background: #0885A9;
      border-radius: 8px;
      position: relative;
      top: -2px;
    }
  }
}
</style>
